<template>
  <div>
    <div
      class="alert text-left formatted-text"
      :class="{
        'alert-danger': message.error,
        'alert-success': !message.error,
      }"
      role="alert"
      v-show="message.display"
    >
      {{ this.message.content }}
    </div>
    <div class="row">
      <div class="col-md-4">
        <form>
          <div class="form-group row">
            <label class="col-md-3 text-right">Action:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.action
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Application:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">
              {{ log.application }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Description:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.description
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Ajouté le:</label>
            <label
              v-if="log.created_at"
              type="text"
              class="col-md-8 text-left font-weight-bold"
            >
              {{
                log.created_at
                  | dateParse("YYYY-MM-DD HH:mm:ss")
                  | dateFormat("DD/MM/YYYY HH:mm:ss")
              }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">IP:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.ip
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Lang:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.lang
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Méthode:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.method
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Referrer:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.referrer
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Route:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.route
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Type:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.type
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">User agent:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.user_agent
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">ID:</label>
            <label type="text" class="col-md-8 text-left font-weight-bold">{{
              log.id
            }}</label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Email de l'utilisateur:</label>
            <label
              v-if="log.user"
              type="text"
              class="col-md-8 text-left font-weight-bold"
            >
              {{ log.user.email }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Nom d'utilisateur:</label>
            <label
              v-if="log.user"
              type="text"
              class="col-md-8 text-left font-weight-bold"
              >{{ log.user.name }}</label
            >
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right">Profile de l'utilisateur:</label>
            <pre class="col-md-8 text-left font-weight-bold">
              <code>
                {{ log.profile }}
              </code>
            </pre>
            <!-- <label
              v-if="log.profile"
              type="text"
              class="col-md-7 text-left font-weight-bold"
              >{{ log.profile.name }}</label
            > -->
          </div>
          <div class="form-group row">
            <label class="col-md-3 text-right"> Statut réponse: </label>
            <label
              type="text"
              class="col-md-8 text-left font-weight-bold"
              v-if="log.response"
            >
              <span
                :class="{
                  'badge badge-success': log.response.status == 200,
                  'badge badge-danger': log.response.status == 500,
                  'badge badge-warning':
                    log.response.status !== 200 && log.response.status !== 500,
                }"
              >
                {{ log.response.status }}
              </span>
            </label>
          </div>
        </form>
      </div>
      <div class="col-md-8">
        <form>
          <div class="form-group row">
            <label class="col-md-5 text-left"> contenu réponse: </label>
            <pre v-if="log.response" class="text-left font-weight-bold">
              <code>
                {{ log.response.content }}
              </code>
            </pre>
            <!-- <label
              type="text"
              class="col-md-7 text-left font-weight-bold"
              v-if="log.response"
            >
              {{ log.response.status }}
            </label> -->
          </div>
          <div class="form-group row">
            <label class="col-md-5 text-left">Paramètres: </label>
            <pre class="text-left font-weight-bold">
              <code>
                {{ log.params }}
              </code>
            </pre>
          </div>
          <!-- <div class="form-group row">
            <label class="col-md-5 text-right">Durée du séjour:</label>
            <label type="text" class="col-md-7 text-left font-weight-bold">
              {{ demand.stayin_duration }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-5 text-right"
              >Destination suivante après Bénin:
            </label>
            <label type="text" class="col-md-7 text-left font-weight-bold">
              {{ demand.country_after_departure_name }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-5 text-right">Moyens de subsistance:</label>
            <label type="text" class="col-md-7 text-left font-weight-bold">
              {{ demand.stayin_garanty }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-5 text-right">Garantie de retour:</label>
            <label type="text" class="col-md-7 text-left font-weight-bold">
              {{ demand.return_garanty }}
            </label>
          </div>
          <div class="form-group row">
            <label class="col-md-5 text-right">Motif du voyage:</label>
            <label type="text" class="col-md-7 text-left font-weight-bold">
              {{ demand.travel_purpose }}
            </label>
          </div> -->
        </form>
      </div>
    </div>
    <div class="form-group row">
      <!-- <label class="col-md-8"></label> -->
      <div class="col-md-12 text-center">
        <router-link
          class="btn btn-dark action-btn-cancel"
          :to="{ name: 'logs' }"
        >
          Retourner
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LogViewForm",
  data() {
    return {
      country: {},
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters({ log: "log" }),
  },
  mounted() {},

  methods: {},
};
</script> 